import React, { useEffect } from 'react'
import { Badge, Button, Col } from 'antd'
import useNotification from '../../hooks/notification'
import { CREATE_NEW_EVENTS } from '../../services/graphql-subscription/notification/tags'
import { BellFilled, BellOutlined } from '@ant-design/icons'
import '../../css/notification.css'
import { useState } from 'react'
import _ from 'lodash'
import useToast from '../../hooks/toast'
import { connect } from 'react-redux'
import {
  isEventUpdated,
  getEvents,
  getDifference,
} from '../../store/action/event.action'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
const RemainderNotification = (props) => {
  const location = useLocation()
  const newEvent = useNotification({
    gqltag: CREATE_NEW_EVENTS,
    params: { customerId: props.customerId, companyId: props.companyId },
  })

  const { successToast } = useToast()

  // Handle onReminders subscription
  useEffect(() => {
    if (!_.isEmpty(newEvent.notification)) {
      const { onReminders } = newEvent.notification
      if (onReminders) {
        const handleFetchEvents = async () => {
          await fetchEvents()
          if (location.pathname != '/events')
            successToast('Received an update in Reminders!')
        }
        handleFetchEvents()
      }
    }

    return () => {
      if (newEvent.notification.unsubscribe) newEvent.unsubscribe()
    }
  }, [newEvent.notification])

  const fetchEvents = async () => {
    try {
      await props.getDiffs({
        customer: props.customer?._id,
        company: props.company?._id,
      })
      await props.isEventUpdated({
        customer: props.customer?._id,
        company: props.company?._id,
      })

      await props.getEvents({
        surgerytype: props.surgerytype,
        customer: props.customer?._id,
        company: props.company?._id,
      })
    } catch (error) {
      console.log(error, 'Error in NotificationBell FetchEvent')
    }
  }

  return <></>
}
const mapDispatchToProps = (dispatch) => {
  return {
    isEventUpdated: (params) => dispatch(isEventUpdated(params)),
    getEvents: (params) => dispatch(getEvents(params)),
    getDiffs: (params) => dispatch(getDifference(params)),
  }
}
const mapStateToProps = (state) => {
  return {
    customer: state.profile.customer,
    company: state.profile.company,
    surgerytype: state.event.surgerytype,
    // isUpdated: state.event.isUpdated,
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RemainderNotification)
